import FloatingMenu from "../FloatingMenu";
import "./HomeContent.css";
import { Link } from "react-router-dom";

const tracks=[
  {id:1, track_name:"Delivery Leadership", path:"/delivery-leadership", img:"/images/Home/DL-tile.png"},
  {id:2, track_name:"Bundle Skills", path:"/bundleSkills", img:"/images/Home/BS-tile.png"}
];

function HomeContent() {

  return (
    <>
    <FloatingMenu/>
      <div className="banner">
        <img
          src={process.env.PUBLIC_URL + "/images/Home/home-banner.png"}
          alt="banner"
          className="home-banner"
        />
        <h1 className="banner-content">Training Nomination Request Tool</h1>
      </div>
      <div className="about_section">
        <h3 className="about_header">About</h3>
        <p className="about_para">
          At L&TT, we provide support in planning and executing training for
          ATCI employees. Some Training programs requires business teams to
          provide the nominations instead of allowing employees to
          self-nominate. This “Training nomination Request tool” allows the
          business teams to review the scheduled training sessions, upload the
          training nominations for a specific Training session and view their
          nomination status as and when required. The tool also allows the SMEs
          to review the nominees profile and approve/reject the nomination. It
          also allows the admin team to select nomination on FIFO basis.
        </p>
      </div>
      <div className="course_section">
        {tracks
          .map((track) =>(
              <>
                <div
                  key={track.id}
                  className="course_card"
                >
                  <Link to={track.path}>
                    <img
                      src={process.env.PUBLIC_URL + track.img}
                      alt="course"
                      className="course_img"
                    />
                    <div className="course_content">
                      <h3 className="course_header">{track?.track_name}</h3>
                      
                    </div>
                  </Link>
                </div>
              </>
            ))}
      </div>
    </>
  );
}

export default HomeContent;
